/**
 * ISO/UTC 시간을 한국시간(KST) 문자열로 변환
 * @param {string|Date} dt - ISO 문자열 또는 Date 객체
 * @param {string} format - 'datetime'(기본), 'date', 'time'
 * @returns {string} 한국시간 문자열 (예: 2026-04-15 09:57:41)
 */
export function formatKST(dt, format = 'datetime') {
    if (!dt) return '-';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '-';

    const options = { timeZone: 'Asia/Seoul' };
    const pad = (n) => String(n).padStart(2, '0');

    const Y = d.toLocaleString('en-US', { ...options, year: 'numeric' });
    const M = pad(d.toLocaleString('en-US', { ...options, month: '2-digit' }));
    const D = pad(d.toLocaleString('en-US', { ...options, day: '2-digit' }));
    const h = pad(d.toLocaleString('en-US', { ...options, hour: '2-digit', hour12: false }));
    const m = pad(d.toLocaleString('en-US', { ...options, minute: '2-digit' }));
    const s = pad(d.toLocaleString('en-US', { ...options, second: '2-digit' }));

    if (format === 'date') return `${Y}-${M}-${D}`;
    if (format === 'time') return `${h}:${m}:${s}`;
    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
}
